import { useEffect, useState } from 'react';
import { eventsApi } from '../../../api/eventsApi';
import { sessionsApi } from '../../../api/sessionsApi';

const RECENT_SESSIONS_LIMIT = 8;
const ACTIVE_EVENTS_LIMIT = 5;
const REQUEST_TIMEOUT_MS = 8000;

const listOf = (data, key) => (Array.isArray(data?.[key]) ? data[key] : Array.isArray(data?.results) ? data.results : []);

const loadRecentSessions = (signal) => sessionsApi.list(
  { page: 1, per_page: RECENT_SESSIONS_LIMIT, ordering: 'date_desc', compact: true, include_total: false },
  { signal }
);

const loadActiveEvents = (signal) => eventsApi.getAll(
  { skip: 0, limit: ACTIVE_EVENTS_LIMIT, status_filter: 'ONGOING' },
  { signal }
);

/** Runs `request(signal)` once with a timeout; returns [items, loading, error]. */
const useTimedList = (request, key, errorMessage) => {
  const [state, setState] = useState({ items: [], loading: true, error: null });
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
    request(controller.signal)
      .then((data) => active && setState({ items: listOf(data, key), loading: false, error: null }))
      .catch(() => active && setState({ items: [], loading: false, error: errorMessage }));
    return () => {
      active = false;
      window.clearTimeout(timer);
      controller.abort();
    };
  }, [request, key, errorMessage]);
  return [state.items, state.loading, state.error];
};

export const useRecentSessions = () => useTimedList(loadRecentSessions, 'sessions', 'Recent sessions could not be loaded.');

export const useActiveEvents = () => useTimedList(loadActiveEvents, 'events', 'Active events could not be loaded.');
